import { useState } from "react";
import { useEditorContext } from "@/src/contexts/editorContext";
import SettingsToggle from "./SettingsToggle";
import AcceptTosPopup from "@/src/components/Popups/AcceptTosPopup";
import QuarkleTooltip from "@/src/components/ui/quarkle-tooltip";
import { Lock, Wine } from "lucide-react";

export default function OpenExpressionSwitch() {
  const [openPopup, setOpenPopup] = useState(false);
  const { subscription, openExpressionAllowed, openExpressionEnabled, dispatch: editorDispatch } = useEditorContext();
  const isProUser = subscription.subscription_type === "pro";

  async function handleCheckedChange() {
    if (!openExpressionAllowed) {
      setOpenPopup(true);
      return;
    }
    editorDispatch({ type: "openExpressionEnabled/set", payload: !openExpressionEnabled });
  }

  const icon = !isProUser ? (
    <Lock className="h-3.5 w-3.5" style={{ color: "var(--qk-muted)" }} data-tooltip-id="open-expression-switch" data-tooltip-content="Upgrade to Access" />
  ) : (
    <Wine className="h-3.5 w-3.5" style={{ color: "var(--qk-pink-deep)" }} />
  );

  return (
    <SettingsToggle
      label="Open Expression (NSFW)"
      checked={openExpressionEnabled}
      onChange={handleCheckedChange}
      disabled={!isProUser}
      icon={icon}
      tooltip={!isProUser ? <QuarkleTooltip id="open-expression-switch" /> : null}
    >
      {openPopup && <AcceptTosPopup open={openPopup} closeModal={() => setOpenPopup(false)} editorDispatch={editorDispatch} />}
    </SettingsToggle>
  );
}
